module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAAXNSR0IArs4c6QAAALtJREFUGBltkE0KwjAQRr8U9R4ex4WSpIgiuhHElS50oyj0Fr2BuBFP5c4bWJv4JS1C0gSG/Lw3k0kEEsNqTGBRQuDai7nNkcPgTqFPoQ64VZhbiYphuT6FUGPFw28LDyFUWBPWhIb372K48aCB2wC6DTNfvqzErQN5kDEu7NZwXlDepySwwvLfoMYxLWnMKDZPlDinJQXNSp+2p8JJIjb5k2N29OBPDkiLjuASWGFE+KT0TgpemmKICtkPKpZWvTqnzy0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/drawer-back-arrow.png
// module id = 363
// module chunks = 0 1 2